/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { FieldFoundation } from '../field/field-foundation';
export class TextFieldFoundation extends FieldFoundation {
    constructor(_adapter) {
        super(_adapter);
        this._adapter = _adapter;
    }
    initialize() {
        super.initialize();
        this._adapter.detectTextarea();
    }
}
